import React from 'react';

const InputCheckbox = ({ label, register, errors, validation }) => {
  return (
    <div className="flex flex-col items-center">
      <label className="flex justify-center items-start cursor-pointer">
        <input
          type="checkbox"
          {...register(validation.name, validation.rules)}
          className="cursor-pointer mr-2"
          style={{
            accentColor: '#09A391',
            width: '24px',
            height: '24px'
          }}
        />
        <span className="font-medium">{label}</span>
      </label>

    </div>
  );
};

export default InputCheckbox;
